module.exports = __webpack_public_path__ + "media/images/testimonials-fd577ca813f3be5b671cacc22ba0fac1.jpg";